
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SparkleIcon } from '../constants.tsx';
import AnimatedParticles from './AnimatedParticles.tsx';

const CTA: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section>
            <div className="max-w-6xl mx-auto px-4 sm:px-8 xl:px-0">
                <div className="cta-box-gradient">
                    <div className="cta-inner-box px-4 py-20 lg:py-24">
                        <AnimatedParticles />
                        <div className="text-center relative z-10">
                            <span className="section-badge relative mb-5 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
                                <SparkleIcon />
                                <span>{t('ctaSectionSubtitle')}</span>
                            </span>
                            <h2 className="text-white mb-4.5 text-3xl font-bold sm:text-4xl xl:text-5xl">
                                {t('ctaSectionTitle')}
                            </h2>
                            <p className="max-w-xl mx-auto font-medium mb-9 text-white/80">
                                {t('ctaSectionDescription')}
                            </p>
                             <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4">
                                <a href="https://dash.tad-ai.com" target="_blank" rel="noopener noreferrer" className="cta-button-gradient inline-flex rounded-lg py-3.5 px-8 text-white font-bold ease-in duration-300 hover:opacity-90 shadow-lg">
                                    {t('ctaButton')}
                                </a>
                                <a
                                    href="https://www.tad-ai.com/TadAI-Setup.exe"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                    className="inline-flex items-center gap-2 rounded-lg py-3.5 px-6 text-white font-bold bg-blue-600/30 hover:bg-blue-600/50 border border-blue-400/40 transition-all"
                                >
                                    <span>💻</span>
                                    <span>تحميل لسطح المكتب (Windows)</span>
                                </a>
                                <a
                                    href="https://www.tad-ai.com/TADAI-Instaler.apk"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                    className="inline-flex items-center gap-2 rounded-lg py-3.5 px-6 text-white font-bold bg-emerald-600/30 hover:bg-emerald-600/50 border border-emerald-400/40 transition-all"
                                >
                                    <span>📱</span>
                                    <span>تحميل للأندرويد (APK)</span>
                                </a>
                                <a
                                    href="https://www.tad-ai.com/SARA-AI.apk"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                    className="inline-flex items-center gap-2 rounded-lg py-3.5 px-6 text-white font-bold bg-purple-600/30 hover:bg-purple-600/50 border border-purple-400/40 transition-all"
                                >
                                    <span>🤖</span>
                                    <span>تحميل تطبيق سارة (APK)</span>
                                </a>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTA;
